/* eslint-disable react/prop-types */
import { Accordion, AccordionItem as Item } from "@szhsin/react-accordion";
import chevronDown from "../assets/chevron-down.svg";
import styles from "../styles.module.css";
import '../output.css';
import { useState } from "react";
/**
 * @type {React.ExoticComponent<import('@szhsin/react-accordion').AccordionItemProps>}
 */
const AccordionItem = ({ header, ...rest  }) => (
  <Item
    {...rest}
    header={
      <>
        {header}
        <img className={styles.chevron} src={chevronDown} alt="Chevron Down" />
      </>
    }
    className={styles.item}
    buttonProps={{
      className: ({ isEnter }) =>
        `${styles.itemBtn} ${isEnter && styles.itemBtnExpanded}`,
    }}
    contentProps={{ className: styles.itemContent }}
    panelProps={{ className: styles.itemPanel }}
  />
);

function Desc({desc}) {
  return ( <ul className="desc">
      <span>{desc?.h1}</span>
      {desc?.peso ? <li>Peso: {desc?.peso}</li> : "" }
      {desc?.tenedor ? <li>Tenedor: {desc?.tenedor}</li> : "" }
      {desc?.tipoDeMarco ? <li>Tipo de Marco: {desc?.tipoDeMarco}</li> : "" }
      {desc?.tamañoDeLasLlantas ? <li>Tamaño de las Llantas: {desc?.tamañoDeLasLlantas}</li> : "" }
      {desc?.frenos ? <li>Frenos: {desc?.frenos}</li> : "" }
      {desc?.grupo ? <li>Grupo: {desc?.grupo}</li> : "" }
      {desc?.manubrio ? <li>Manubrio: {desc?.manubrio}</li> : "" }
  </ul>
  )
}

export default function AccordionBike({ data, setSize }) {
  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontFamily: 'Arial, sans-serif',
  };

  const cellStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'center',
  }; 


  const tallas = typeof data?.tallas === "string" ? JSON.parse(data?.tallas) : data?.tallas;

  return (
    <div className={styles.container} style={{width: "440px",  borderRadius: "5px"}} >
      <div className={styles.accordion} style={{width: "400px"}}>
        {/* `transitionTimeout` prop should be equal to the transition duration in CSS */}
        <Accordion transition transitionTimeout={250}>
          <div style={{width: "100%"}}>
          <AccordionItem header="Características">
           <Desc desc={data?.description}></Desc>
          </AccordionItem>

          <AccordionItem header="Dimensiones">
          <table style={tableStyle}>
      <thead>
        <tr>
          <th style={cellStyle}>Tallas</th>
        </tr>
      </thead>
      <tbody>
        {data?.dimensions?.map((dimension, index) => (
          <tr key={index}>
            <td style={cellStyle}>{dimension}</td>
          </tr>
        ))}
      </tbody>
    </table>
            
          </AccordionItem>
          </div>
        </Accordion>
      </div>
    </div>
  );
}
